import moment from 'moment'

export default {
  getMessage(field, args) {
    return field
  },
  validate(value, args) {
    let _value = moment(value, 'DD/MM/YYYY', true)
    return _value.isValid()
  }
}
